import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { httpRequest } from "../../redux/Action";
import { API_END_POINTS } from "../../api/ApiEndPonts";
import { motion } from "framer-motion";
import ComingSoon from "../pages/ComingSoon";

function Qbank() {
  const dispatch = useDispatch();

  const subjectState =
    useSelector((state) => state.apiReducer.getAllSubjects) || {};

  const { response, loading, error } = subjectState;
  // console.log("API RESPONSE:", response);

  // ✅ API CALL
  useEffect(() => {
    dispatch(
      httpRequest({
        key: API_END_POINTS.getAllSubjects.KEY,
      }),
    );
  }, []);

  // ✅ DATA EXTRACT
  const subjects = Array.isArray(response?.data) ? response.data : [];
  // console.log("Subjects:", subjects);

  return (
    <div className="">


<ComingSoon type="questions" />


      {/* {loading && <p>Loading...</p>}

      {error && Object.keys(error).length > 0 && (
        <p style={{ color: "red" }}>
          {typeof error === "object"
            ? error.message || JSON.stringify(error)
            : error}
        </p>
      )}
      <div className="row g-4">
        {subjects.map((s, i) => (
          <div className="col-12 col-md-6 col-lg-4" key={s._id || i}>
            <Link
              to={`/user/subjects/${s._id}/topics`}
              className="text-decoration-none"
            >
              <div className="modern-subject-card">
                <div className="card-header-flex">
                  <div className="icon-wrapper">
                    <i className="bi bi-journal-bookmark-fill"></i>
                  </div>
                  <span className="badge-pill">{s.code || "CORE"}</span>
                </div>

                <div className="card-body-content">
                  <h5 className="subject-title">{s.title}</h5>
                  <p className="subject-subtitle">
                    Master the fundamentals of {s.title}
                  </p>
                </div>

                <div className="card-footer-progress">
                  <div className="progress-info">
                    <span>Progress</span>
                    <span className="percentage-text">70%</span>
                  </div>
                  <div className="progress-track">
                    <div
                      className="progress-fill"
                      style={{ width: "70%" }}
                    ></div>
                  </div>
                </div>

                <div className="hover-arrow">
                  <i className="bi bi-chevron-right"></i>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div> */}

    </div>
  );
}



export default Qbank;
